(function () {
  var STORAGE_KEY = 'happymami_teat_sku';
  var CHOICES_KEY = 'happymami_teat_choices';
  var CODES_KEY = 'happymami_teat_codes';
  var FLOW_LETTER = { 1: 'L', 2: 'M', 3: 'R', 4: 'C' };
  var TEAT_TO_N = {
    T1L: 'N10', T2L: 'N27', T3L: 'N42', T4L: 'N72',
    T1M: 'N34', T2M: 'N98', T3M: 'N59', T4M: 'N37',
    T1R: 'N06', T2R: 'N51', T3R: 'N08', T4R: 'N64',
    T1C: 'N89', T2C: 'N14', T3C: 'N05', T4C: 'N16',
  };

  function storageGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function storageSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {}
  }
  function storageRemove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {}
  }
  function normalizeAnatomy(value) {
    var match = String(value || '')
      .toUpperCase()
      .match(/T[1-4](?![0-9])/);
    return match ? match[0].slice(0, 2) : '';
  }
  function normalizeTeat(value) {
    var match = String(value || '')
      .toUpperCase()
      .match(/T[1-4][LMRC]/);
    return match ? match[0] : '';
  }
  function teatFromFlow(anatomy, flowCode) {
    var letter = FLOW_LETTER[Number(flowCode)] || FLOW_LETTER[flowCode];
    return anatomy && letter ? anatomy + letter : '';
  }
  function readChoices() {
    try {
      var parsed = JSON.parse(storageGet(CHOICES_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }
  function readCodes() {
    try {
      var parsed = JSON.parse(storageGet(CODES_KEY) || '[]');
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch (e) {}
    return readChoices()
      .filter(function (row) {
        return row && row.step && row.code != null;
      })
      .map(function (row) {
        return { step: row.step, code: String(row.code) };
      });
  }

  // Código de las cuatro respuestas (P1-P2-P3-P4 = M1-M4), solo cifras y en ese orden, igual en todos los idiomas.
  // Si falta alguna respuesta no se escribe nada: un código a medias no sirve.
  function choiceCode() {
    var order = ['M1', 'M2', 'M3', 'M4'];
    var byStep = {};
    readCodes().forEach(function (row) {
      if (row && row.step) byStep[row.step] = String(row.code);
    });
    var out = '';
    for (var i = 0; i < order.length; i += 1) {
      if (!/^[1-3]$/.test(byStep[order[i]] || '')) return '';
      out += byStep[order[i]];
    }
    return out;
  }

  function bind(root) {
    if (!root || root.dataset.hmBound === '1') return;
    root.dataset.hmBound = '1';

    var configEl = document.getElementById('happymami-teat-config');
    var config = {};
    try {
      config = JSON.parse(configEl ? configEl.textContent : '{}');
    } catch (e) {
      config = {};
    }

    var VARIANTS = {};
    function indexSku(sku, variant) {
      if (!variant || !sku) return;
      var raw = String(sku).trim();
      if (!raw) return;
      VARIANTS[raw] = variant;
      VARIANTS[raw.toUpperCase()] = variant;
      var teat = normalizeTeat(raw);
      if (teat) {
        VARIANTS[teat] = variant;
        if (TEAT_TO_N[teat]) VARIANTS[TEAT_TO_N[teat]] = variant;
      }
      var upper = raw.toUpperCase();
      Object.keys(TEAT_TO_N).forEach(function (teatSku) {
        if (TEAT_TO_N[teatSku] === upper) VARIANTS[teatSku] = variant;
      });
    }
    Object.keys(config.variants || {}).forEach(function (sku) {
      indexSku(sku, config.variants[sku]);
    });

    function findVariant(sku) {
      var teat = normalizeTeat(sku);
      if (teat && VARIANTS[teat]) return VARIANTS[teat];
      var raw = String(sku || '').trim().toUpperCase();
      if (raw && VARIANTS[raw]) return VARIANTS[raw];
      if (teat && TEAT_TO_N[teat] && VARIANTS[TEAT_TO_N[teat]]) return VARIANTS[TEAT_TO_N[teat]];
      return null;
    }

    function infoRoot() {
      return (
        root.closest('.product__info-container') ||
        document.getElementById('ProductInfo-' + (root.dataset.section || ''))
      );
    }

    function productForm() {
      return (
        (config.productFormId && document.getElementById(config.productFormId)) ||
        document.querySelector('form[data-type="add-to-cart-form"]')
      );
    }

    function renderDesign(choices, teatSku) {
      var box = root.querySelector('[data-hm-design]');
      var list = root.querySelector('[data-hm-design-list]');
      if (!list) return;
      var picked = Array.isArray(choices) && choices.length ? choices : readChoices();
      var rows = picked.filter(function (row) {
        return row && (row.titulo || row.opcion) && row.step !== 'M5';
      });
      if (typeof window.happymamiLocalizeChoices === 'function') rows = window.happymamiLocalizeChoices(rows);
      if (!rows.length && teatSku) rows = [{ titulo: 'Tetina', opcion: teatSku }];
      list.innerHTML = rows
        .map(function (row, index) {
          var title = String(row.titulo || '').replace(/</g, '');
          var option = String(row.opcion || '').replace(/</g, '').replace(/\n/g, ' ');
          var step = String(row.step || ['M1', 'M2', 'M3', 'M4'][index] || '').replace(/[^\w]/g, '');
          var inner = '<span class="hm-design__label">' + title + ': </span><span class="hm-design__value">' + option + '</span>';
          if (!step) return '<div>' + inner + '</div>';
          return '<button type="button" class="hm-design__row" data-hm-edit-step="' + step + '">' + inner + '</button>';
        })
        .join('');
    }

    function selectedFlow() {
      var el = root.querySelector('[data-hm-flow].is-selected');
      return el ? el.getAttribute('data-hm-flow') : '';
    }

    function currentSku() {
      return teatFromFlow(normalizeAnatomy(storageGet(STORAGE_KEY)), selectedFlow());
    }

    // El botón no enseña precio: «Añadir al carrito» cuando está todo elegido, «Elegir opciones» si falta algo.
    function setCta(ready) {
      var info = infoRoot();
      var label = info && info.querySelector('[id^="HmAtcLabel"]');
      if (!label) return;
      var text = function (path, fallback) {
        return (typeof window.hmT === 'function' && window.hmT(path)) || fallback;
      };
      label.textContent = ready
        ? text('bundle.add_to_cart', 'Añadir al carrito')
        : text('bundle.choose_options', 'Elegir opciones');
    }

    function refreshCta() {
      setCta(root.classList.contains('is-ready') && !!selectedFlow());
    }

    function applySelectedVariant() {
      var sku = currentSku();
      if (!sku) return false;
      return setVariant(sku);
    }

    function validateTeat() {
      root.querySelectorAll('.is-invalid').forEach(function (el) {
        el.classList.remove('is-invalid');
      });
      var anatomy = normalizeAnatomy(storageGet(STORAGE_KEY));
      if (!anatomy) {
        var wizard = root.querySelector('#happymami-wizard-container');
        if (window.happymamiFlow) window.happymamiFlow.scrollTo(wizard || root);
        return false;
      }
      var flowSection = root.querySelector('[data-hm-required="flow"]');
      if (!selectedFlow()) {
        if (flowSection) flowSection.classList.add('is-invalid');
        if (window.happymamiFlow) window.happymamiFlow.scrollTo(flowSection || root);
        return false;
      }
      var sku = currentSku();
      var variant = findVariant(sku);
      if (!sku || !variant || !variant.id) {
        alert(
          'Tetina ' +
            (sku || anatomy) +
            ' calculada, pero no hay una variante de Shopify con ese SKU.'
        );
        return false;
      }
      setVariant(sku);
      return true;
    }

    function addProperty(form, name, value) {
      if (!name || value == null || String(value).trim() === '') return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      input.value = String(value).trim();
      input.setAttribute('data-hm-prop', '');
      form.appendChild(input);
    }

    function setProperties(sku) {
      var form = productForm();
      if (!form) return;
      form.querySelectorAll('[data-hm-prop]').forEach(function (el) {
        el.remove();
      });
      addProperty(form, 'Tetina', sku);
      addProperty(form, '_tipo', 'tetina');
      addProperty(form, '_hm_tetina', sku);
      addProperty(form, '_hm_choice', choiceCode());
      readChoices().forEach(function (row) {
        if (!row || !row.titulo) return;
        var key = String(row.titulo)
          .replace(/[\[\]]/g, '')
          .replace(/:/g, '')
          .trim();
        if (!key || key.charAt(0) === '_' || key === 'Tetina') return;
        if (key.length > 40) key = key.slice(0, 40);
        addProperty(form, key, row.opcion);
      });
    }

    function updatePrice(variant) {
      if (!variant || !variant.price) return;
      var info = infoRoot();
      // Con un set de varias tetinas el precio mostrado es el del pack (happymami-teat-packs.js).
      if (info && info.classList.contains('hm-set-selected')) return;
      var price = info && info.querySelector('.price-item--regular');
      if (price) price.textContent = variant.price;
    }

    function setVariant(sku) {
      var variant = findVariant(sku);
      if (!variant || !variant.id) return false;
      var productInfo = root.closest('product-info');
      document.querySelectorAll('input.product-variant-id, form[data-type="add-to-cart-form"] input[name="id"]').forEach(function (input) {
        input.value = variant.id;
        input.disabled = variant.available === false;
      });
      if (productInfo && typeof productInfo.updateVariantInputs === 'function') {
        productInfo.updateVariantInputs(variant.id);
      }
      var submit = document.querySelector('[id^="ProductSubmitButton"]');
      if (submit) submit.disabled = variant.available === false;
      setProperties(sku);
      updatePrice(variant);
      return true;
    }

    function showAfter(sku, choices, animated, opts) {
      opts = opts || {};
      var wizard = root.querySelector('#happymami-wizard-container');
      var after = document.getElementById('happymami-teat-after');
      var status = root.querySelector('[data-hm-status-after]');
      var success = root.querySelector('[data-hm-success]');
      if (status) {
        status.textContent =
          typeof window.hmT === 'function' ? window.hmT('teat_ui.flow_prompt') : 'Elige el flujo de tu tetina.';
      }
      renderDesign(choices, sku);
      var info = infoRoot();
      if (info) info.classList.add('is-teat-ready');
      root.classList.add('is-ready');
      var applied = applySelectedVariant();
      refreshCta();
      var submit = document.querySelector('[id^="ProductSubmitButton"]');
      if (submit && !applied) submit.disabled = false;
      if (animated && window.happymamiFlow && window.happymamiFlow.celebrate) {
        window.happymamiFlow.celebrate(wizard, after, opts.skipSuccess ? null : success, {
          successMs: 1600,
          scrollTo: root,
        });
        return;
      }
      if (wizard) wizard.hidden = true;
      if (after) after.hidden = false;
    }

    function showWizard(animated, edit) {
      var wizard = root.querySelector('#happymami-wizard-container');
      var after = document.getElementById('happymami-teat-after');
      function startEdit() {
        var info = infoRoot();
        if (info) info.classList.remove('is-teat-ready');
        root.classList.remove('is-ready');
        setCta(false);
        var submit = document.querySelector('[id^="ProductSubmitButton"]');
        if (submit) submit.disabled = true;
        document.dispatchEvent(
          new CustomEvent('happymami:edit', {
            bubbles: true,
            detail: {
              mode: (edit && edit.mode) || 'all',
              step: edit && edit.step,
              codes: readCodes(),
              choices: readChoices(),
            },
          })
        );
      }
      if (animated && window.happymamiFlow) {
        window.happymamiFlow.swap(after, wizard, {
          scroll: true,
          scrollEl: root || wizard,
          prepare: startEdit,
        });
        return;
      }
      if (wizard) wizard.hidden = false;
      if (after) after.hidden = true;
      if (edit) startEdit();
    }

    var toggle = root.querySelector('[data-hm-design-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var box = root.querySelector('[data-hm-design]');
        if (!box) return;
        var closed = box.classList.toggle('is-closed');
        toggle.setAttribute('aria-expanded', closed ? 'false' : 'true');
      });
    }

    var designList = root.querySelector('[data-hm-design-list]');
    if (designList) {
      designList.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-hm-edit-step]');
        if (!btn) return;
        if (window.happymamiFlow && window.happymamiFlow.busy) return;
        showWizard(true, { mode: 'one', step: btn.getAttribute('data-hm-edit-step') });
      });
    }

    var resetBtn = root.querySelector('[data-hm-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        if (window.happymamiFlow && window.happymamiFlow.busy) return;
        showWizard(true, { mode: 'all' });
      });
    }

    root.querySelectorAll('[data-hm-flow]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-hm-flow]').forEach(function (el) {
          el.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        var section = btn.closest('[data-hm-required]');
        if (section) section.classList.remove('is-invalid');
        applySelectedVariant();
        refreshCta();
      });
    });

    root._hmRenderDesign = renderDesign;
    root._hmShowAfter = showAfter;
    root._hmShowWizard = showWizard;
    root._hmValidateTeat = validateTeat;

    var saved = normalizeAnatomy(storageGet(STORAGE_KEY));
    if (saved) showAfter(saved, readChoices());
    refreshCta();
  }

  function boot() {
    bind(document.getElementById('happymami-teat'));
  }

  if (!window.__happymamiTeatListeners) {
    window.__happymamiTeatListeners = true;
    document.addEventListener('happymami:pharma-ready', function () {
      var teat = document.getElementById('happymami-teat');
      if (!teat || typeof teat._hmRenderDesign !== 'function') return;
      teat._hmRenderDesign(readChoices(), storageGet(STORAGE_KEY));
    });
    document.addEventListener('happymami:complete', function (event) {
      var data = event.detail || {};
      var sku = normalizeAnatomy(data.teat || data.ref);
      if (!sku) return;
      storageSet(STORAGE_KEY, sku);
      var choices = data.choices || data.elecciones;
      if (choices && choices.length) storageSet(CHOICES_KEY, JSON.stringify(choices));
      if (data.codes && data.codes.length) storageSet(CODES_KEY, JSON.stringify(data.codes));
      boot();
      var root = document.getElementById('happymami-teat');
      if (root && typeof root._hmShowAfter === 'function') {
        root._hmShowAfter(sku, choices && choices.length ? choices : readChoices(), true, {
          skipSuccess: !!data.fromEdit,
        });
        return;
      }
      var wizard = document.getElementById('happymami-wizard-container');
      var after = document.getElementById('happymami-teat-after');
      if (wizard) wizard.hidden = true;
      if (after) after.hidden = false;
    });
    document.addEventListener('happymami:cancel-edit', function () {
      var root = document.getElementById('happymami-teat');
      var sku = normalizeAnatomy(storageGet(STORAGE_KEY));
      if (!root || !sku || typeof root._hmShowAfter !== 'function') return;
      root._hmShowAfter(sku, readChoices(), true, { skipSuccess: true });
    });
    document.addEventListener('product-info:loaded', boot);
    document.addEventListener(
      'submit',
      function (e) {
        var teatRoot = document.getElementById('happymami-teat');
        if (!teatRoot || !teatRoot.classList.contains('is-ready') || typeof teatRoot._hmValidateTeat !== 'function') {
          return;
        }
        var form = e.target;
        if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
        if (!teatRoot._hmValidateTeat()) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );
    document.addEventListener(
      'click',
      function (e) {
        var submit = e.target && e.target.closest && e.target.closest('[id^="ProductSubmitButton"]');
        if (!submit) return;
        var teatRoot = document.getElementById('happymami-teat');
        if (!teatRoot || !teatRoot.classList.contains('is-ready') || typeof teatRoot._hmValidateTeat !== 'function') {
          return;
        }
        if (!teatRoot._hmValidateTeat()) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  } else {
    boot();
  }
})();
